
<div class="bgimg-1" id="Section1" #Section1>
  <div class="bgCaption">
    <div class="bgCaptionSmall">Hey I'm</div>
    <span>Aakash Ninama</span>
  </div>
  <div class="bgNavigation">
    <a href="#Section2" (click)="scroll(Section2)">
        <i class="fa fa-arrow-down bounce"></i>
          <!-- <i class="fa fa-arrow-circle-down"></i> -->
    </a>
  </div>
</div>

<div class="bgimg-2" #Section2>
  <h3 class="text-center mb-5">About Me</h3>
  <div class="row">
    <div class="col-sm-6 mb-5">
      <!-- <div class="row">
        <p><span class="iHeading">I</span>lived in Gandhinagar,Gujarat</p>
        <p><span class="iHeading">I</span>moved to Nasik,Maharastra for Diploma in Computer Science.</p>
        <p><span class="iHeading">I</span>now live in Pune,Maharastra for Graduation</p>
        <p><span class="iHeading">I</span>watch a lot movies and I used to run a weekly movie night</p>
        <p><span class="iHeading">I</span>write code for front-ent as well as back-end.</p>
        <p><span class="iHeading">I</span>have started my career with for H &amp; R Block as a Software Engineer and still working.</p>
        <p><span class="iHeading">I</span>have more details in my resume if you need.</p>
      </div> -->
      <div class="row text-decoration mt-4">
          <div class="slider-wrapper">
              Lived in
              <div class="slider">
                <div class="text1">  <h2>Gandhinagar.</h2> </div>
                <div class="text2"><h2>Nasik.</h2></div>
                <div class="text3"><h2>Ahmedabad.</h2></div>
              </div>
              Currently living in PUNE. 
            </div>
        </div>
      <div class="row text-decoration mt-4">
        I am 
          <div class="flip-box">
              <div class="flip-box-inner">
                <div class="flip-box-front">
                  <h2>Frontend</h2>
                </div>
                <div class="flip-box-back">
                  <h2>Backend</h2>
                </div>
              </div>
            </div>
             Developer.     
      </div>
      
      <!-- <div class="row">
          Born and Brought up in Gandhinagar, Gujarat. Moved to Maharastra for further studies. After that started to work with H & R Block as Software Engineer in 2017 for 2 Years. I have worked as a Frontend Developer or Backend Developer on different projects.
            
      </div> -->
      <div class="row text-decoration mt-4">
        Love to watch <img src="./assets/Netflix.png" class="img-netflix">.
      </div>
      <div class="row text-decoration mt-3">
        Currently working with &nbsp;<h2 class="neon text-decoration">H & R Block.</h2>
      </div>
      <div class="row text-decoration mt-3">
          <!-- <p>hi folks, this is typing animation using CSS</p> -->
          <!-- Coding is
<p>Hard
:)<span>|</span></p>  -->

Coding is &nbsp;
    <span class="txt-rotate" data-period="1000"  data-rotate='[ "hard.", "fun.", "LIFE." ]'></span>
      </div>
    </div>
    <div class="col-sm-6">
      <img src="/assets/M.jpeg" alt="Snow" class="hover-effect"  style="width:90%">
    </div>
  </div>
  <div class="row">
    <a href="#Section2" (click)="scroll(Section3)" >
      <i class="fa fa-chevron-down bounce" style="font-size: 2.5rem;color:#fff"></i>
    </a>
  </div>
</div>
<!-- <div class="bgimg-2" ></div> -->
  <div class="bgimg-2" #Section3>
<!-- 
      <div class="bgCaptionHeading">
          <span>Professional Life</span>
      </div>
       -->
      <section id="timeline">
  
          <div class="tl-item">
            
            <div class="tl-bg" style="background-image: url(./assets/hrblock2.jpg)"></div>
            
            <div class="tl-year">
              <p class="f2 heading--sanSerif">2019</p>
            </div>
        
            <div class="tl-content">
              <h1>USTO</h1>
              <p>It is a platform where NRI clients can subscribe different services for filing their US Tax and able to
                  track status of their subscribed services, able to pay for their services, can upload required
                  documents, In case of support client can chat with advisor.</p>
            </div>
        
          </div>
        
          <div class="tl-item">
            
            <div class="tl-bg" style="background-image: url(./assets/hrblock3.jpg)"></div>
            
            <div class="tl-year">
              <p class="f2 heading--sanSerif">2018</p>
            </div>
        
            <div class="tl-content">
              <h1 class="f3 text--accent ttu">eWay Bill 2 Go</h1>
              <p>It is a product of generating e-Way bill through e-Way Bill Manager that can be integrated with your
                  ERP, thereby reducing manual intervention. This tool allows you to create single as well as
                  consolidated e-Way bills</p>
            </div>
        
          </div>
        
          <div class="tl-item">
            
            <div class="tl-bg" style="background-image: url(./assets/hrblock4.jpg)"></div>
            
            <div class="tl-year">
              <p class="f2 heading--sanSerif">2017</p>
            </div>
        
            <div class="tl-content">
              <h1 class="f3 text--accent ttu">My Account</h1>
              <p>
                  It is a platform where clients can subscribe different GST services, able to track status of their
                  subscribed services, able to pay for their services, can upload required documents, In case of
                  support client can chat with advisor and provided access matrix for client’s sub user.
              </p>
            </div>
        
          </div>
        
          <div class="tl-item">
            
            <div class="tl-bg" style="background-image: url(./assets/cdac.jpg)"></div>
            
            <div class="tl-year">
              <p class="f2 heading--sanSerif">2016</p>
            </div>
        
            <div class="tl-content">
              <h1 class="f3 text--accent ttu">C-DAC</h1>
              <p>I have completed my Post Graduation Diploma from IACSD,Akurdi in C-DAC with 71%.</p>
            </div>
        
          </div>
          
          <div class="tl-item">
            
              <div class="tl-bg" style="background-image: url(./assets/graduation.jpeg)"></div>
              
              <div class="tl-year">
                <p class="f2 heading--sanSerif">2015</p>
              </div>
          
              <div class="tl-content">
                <h1>University of Pune</h1>
                <p>Completed Graduation in Computer Science from GHRCEM,Pune with 57%.</p>
              </div>
          
            </div>
          
            <div class="tl-item">
            
                <div class="tl-bg" style="background-image: url(./assets/Diploma.jpeg)"></div>
                
                <div class="tl-year">
                  <p class="f2 heading--sanSerif">2011</p>
                </div>
            
                <div class="tl-content">
                  <h1 class="f3 text--accent ttu">Diploma</h1>
                  <p>I have completed my Diploma in Computer Science from SMES Polytechnic with 71%</p>
                </div>
            
              </div>

              <div class="tl-item">
            
                  <div class="tl-bg" style="background-image: url(./assets/school.jpg)"></div>
                  
                  <div class="tl-year">
                    <p class="f2 heading--sanSerif">2008</p>
                  </div>
              
                  <div class="tl-content">
                    <h1 class="f3 text--accent ttu">SSC</h1>
                    <p>
                        I have completed my SSC from Kendriya Vidyalaya No.1,Gandhinagar with 66%.
                    </p>
                  </div>
              
                </div>
        </section>
      
    <!-- <div class="column">
        <img src="/assets/Pic.jpg" alt="Forest" style="width:100%">
      </div> -->
    <!-- <div class="column">
        <img src="/assets/M.jpg" alt="Mountains" style="width:100%">
      </div> -->
  </div>

<!-- <div style="position:relative;">
  <div style="color:#ddd;background-color:#282E34;text-align:center;padding:50px 80px;text-align: justify;">
  <p>Scroll up and down to really get the feeling of how Parallax Scrolling works.</p>
  </div>
</div> -->

<!-- <div class="bgimg-3">
  <div class="caption">
  <span class="border" style="background-color:transparent;font-size:25px;color: #f7f7f7;">SCROLL UP</span>
  </div>
</div> -->

<!-- <div style="position:relative;">
  <div style="color:#ddd;background-color:#282E34;text-align:center;padding:50px 80px;text-align: justify;">
  <p>Scroll up and down to really get the feeling of how Parallax Scrolling works.</p>
  </div>
</div> -->

<div class="bgimg-1">
  <div class="bgSmallCaption">
    <div class="bgCaptionHeadingSmall">
     <div class="tracking-in-expand">
       Do you like it ?
     </div>
    </div>
    <div class="buttons">
      <button class="slide" href="assets/__Resume.pdf" type="submit" onclick="window.open('assets/__Resume.pdf')">Download Resume</button>
    </div>
      
    <ul class="social-nav model-4">
        <!-- <li><a class="twitter" href="https://twitter.com/vineethtrv"><i class="fa fa-twitter"></i></a></li> -->
        <!-- <li><a class="facebook" href="https://www.facebook.com/vini.thekingal"><i class="fa fa-facebook"></i></a></li> -->
        <li><a class="google-plus" href="mailto:aakashninama92@gmail.com?subject=Liked your page!"><i class="fa fa-google"></i></a></li>
        <li><a class="linkedin" href="https://www.linkedin.com/in/aakash-ninama-2730a3102/"><i class="fa fa-linkedin"></i></a></li>
        <!-- <li><a class="pinterest"><i class="fa fa-pinterest-p"></i></a></li>
        -->
      </ul> 
    <!-- <div class="scene">
        <div class="cube">
          <span class="side top">aakashninama92@gmail.com</span>
          <span class="side front">Email</span>
        </div>
      </div> -->
  </div>
  <div class="bgNavigation">
      <a  (click)="scroll(Section1)">
          <i class="fa fa-angle-double-up bounce"></i>
      </a>
    </div>
</div>